module.exports = __webpack_public_path__ + "img/mail-letter-content.06e481c3.svg";